import React, { useState, useEffect } from 'react';
import API_BASE_URL from '../../../../../Constants';
import { fetchProposalsSubClasses, getProposalClassesFromSubClasses } from '../hooks/proposalFunctions';

const ProposalClasses = ({ formData, setFormData }) => {
    const [proposalsData, setProposalsData] = useState([]);
    const [proposalsSubclassesData, setProposalsSubclassesData] = useState({});
    const [availableSubclasses, setAvailableSubclasses] = useState([]);
    const [showModal, setShowModal] = useState(false);


    // Fetches subclasses 
    useEffect(() => {
        fetchProposalsSubClasses(API_BASE_URL, setProposalsSubclassesData, setProposalsData, getProposalClassesFromSubClasses);
    }, [API_BASE_URL]);

    const handleSubclassSelect = (subclass) => {
        setFormData((prev) => ({
            ...prev,
            proposalSubclass: subclass,
        }));
        setShowModal(false); // Close modal after selecting
    };

    const handleClassChange = (e) => {
        const selectedClassId = e.target.value;

        setFormData((prev) => ({
            ...prev,
            proposalClass: selectedClassId,
            proposalSubclass: "",
        }));

        // Filter available subclasses for the selected class
        const subclasses = proposalsSubclassesData
            .filter((sub) => sub.proposalClass.className === selectedClassId)
            .map((sub) => ({
                subClassId: sub.subClassId,
                subClassName: sub.subClassName,
                proposalClass: {
                    classId: sub.proposalClass.classId,
                    className: sub.proposalClass.className,
                },
            }));

        setAvailableSubclasses(subclasses);
        setShowModal(true);
    };

    return (
        <div>
            {/* Proposal Class Selection */}
            <label className="block text-gray-700 text-sm font-bold mb-2">
                Choose a Proposal Class:
                <select
                    name="proposalClass"
                    value={formData.proposalClass}
                    onChange={handleClassChange}
                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline mt-1"
                >
                    <option value="">Select</option>
                    {proposalsData.map((cls) => (
                        <option key={cls.classId} value={cls.className}>
                            {cls.className}
                        </option>
                    ))}
                </select>
            </label>

            {/* Display Selected Subclass */}
            {formData.proposalSubclass && (
                <p className="text-gray-700 mb-2">
                    Selected Subclass: <strong>{formData.proposalSubclass.subClassName}</strong>
                </p>
            )}
            {showModal && (
                <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 overflow-y-auto">
                    <div className="bg-white p-5 rounded-lg shadow-lg w-full max-w-lg mx-4 my-8">
                        <h2 className="text-lg font-bold mb-4">Select a Proposal Subclass</h2>
                        <strong>
                            <p className="text-gray-700 mb-4">
                                Selected Class:

                                <select
                                    name="proposalClass"
                                    value={formData.proposalClass}
                                    onChange={handleClassChange}
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline mt-1"
                                >
                                    <option value="">Select</option>
                                    {proposalsData.map((cls) => (
                                        <option key={cls.classId} value={cls.className}>
                                            {cls.className}
                                        </option>
                                    ))}
                                </select>
                            </p>
                        </strong>

                        <ul className="max-h-96 overflow-y-auto">
                            {availableSubclasses.map((subclass) => (
                                <li key={subclass.subClassId}>
                                    <button
                                        className="block w-full text-left p-2 hover:bg-gray-200"
                                        onClick={() => handleSubclassSelect(subclass)}
                                    >
                                        {subclass.subClassName}
                                    </button>
                                </li>
                            ))}
                        </ul>
                        <button
                            className="mt-4 bg-red-500 text-white px-4 py-2 rounded"
                            onClick={() => setShowModal(false)}
                        >
                            Cancel
                        </button>
                    </div>
                </div>
            )
            }

        </div >
    );
};

export default ProposalClasses;